import axios from './axios';

// 🔹 取得所有啟用的文章分類 (公開)
export function getEnabledArticleCategories() {
    return axios.get('/api/cms/article-categories/enabled').then(res => res.data);
}

// 🔹 分頁查詢所有文章分類 (需管理員權限)
export function getArticleCategoryPage(page = 0, size = 10, sort = 'createdAt,desc') {
    return axios.get('/api/cms/article-categories', {
        params: { page, size, sort }
    }).then(res => res.data);
}

// 🔹 取得單一文章分類 (需管理員權限)
export function getArticleCategoryById(id) {
    return axios.get(`/api/cms/article-categories/${id}`).then(res => res.data);
}

// 🔹 新增文章分類 (需管理員權限)
export function createArticleCategory(category) {
    return axios.post('/api/cms/article-categories', category).then(res => res.data);
}

// 🔹 更新文章分類 (需管理員權限)
export function updateArticleCategory(id, category) {
    return axios.put(`/api/cms/article-categories/${id}`, category).then(res => res.data);
}

// 🔹 刪除文章分類 (需管理員權限)
export function deleteArticleCategory(id) {
    return axios.delete(`/api/cms/article-categories/${id}`).then(res => res.status === 200 || res.status === 204);
}